<div class="profile-editor-page ticket-request-page ticket-request-dialog">
  <header class="ticket-request-dialog__header">
    <span class="ticket-request-page__badge" aria-hidden="true"><i class="material-icons">tips_and_updates</i></span>
    <div class="ticket-request-dialog__copy">
      <h2>Solicitud de mejoras</h2>
      <p>Propón una mejora para un área o un proyecto.</p>
    </div>
    <button mat-icon-button type="button" class="ticket-request-dialog__close" (click)="onCloseClick()" aria-label="Cerrar">
      <mat-icon>clear</mat-icon>
    </button>
  </header>

  <!--Inicia Form ---------------------------------------------------------->
  <form [formGroup]='options' class="ticket-request-dialog__body">
    <div class="ticket-request-dialog__cols">
      <section class="ticket-request-dialog__col" aria-label="Mejora">
        <!--Empresa-->
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="profile-editor-page__field" *ngIf="!empresaSelect">
          <mat-label>Empresa</mat-label>
          <mat-select required formControlName='empresaCtrl' [(ngModel)]="empresaSeleccionada">
            <mat-option *ngFor="let item of empresas" [value]="item">{{item.razon_social}}</mat-option>
          </mat-select>
          <mat-error *ngIf=' options.controls.empresaCtrl.invalid && (options.controls.empresaCtrl.dirty || options.controls.empresaCtrl.touched) && options.controls.empresaCtrl.errors.required'>
            El campo es requerido.</mat-error>
        </mat-form-field>

        <!--Area/Proyecto-->
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="profile-editor-page__field">
          <mat-label>Área/Proyecto al que aplica</mat-label>
          <input matInput aria-label="Área/Proyecto al que aplica" formControlName='proyectoCtrl' [(ngModel)]="mejora.area_proyecto_aplica" required maxlength="45"
            oninput="this.value = this.value.trim().charAt(0).toUpperCase() + this.value.slice(1)">
          <mat-error *ngIf=' options.controls.proyectoCtrl.invalid && (options.controls.proyectoCtrl.dirty || options.controls.proyectoCtrl.touched) && options.controls.proyectoCtrl.errors.required'>
            El campo es requerido.</mat-error>
        </mat-form-field>

        <!--justificacion-->
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="profile-editor-page__field">
          <mat-label>Descripción propuesta</mat-label>
          <textarea required matInput aria-label="Descripción propuesta" formControlName='justificacionCtrl' [(ngModel)]="tickets.justificacion" maxlength="512" rows="4"
            oninput="this.value = this.value.trim().charAt(0).toUpperCase() + this.value.slice(1)"></textarea>
          <mat-error *ngIf=' options.controls.justificacionCtrl.invalid && (options.controls.justificacionCtrl.dirty || options.controls.justificacionCtrl.touched) && options.controls.justificacionCtrl.errors.required'>
            El campo es requerido.</mat-error>
        </mat-form-field>

        <!--Descripción-->
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="profile-editor-page__field">
          <mat-label>Comentarios adicionales</mat-label>
          <textarea required matInput aria-label="Comentarios adicionales" formControlName='descripcionCtrl' [(ngModel)]="comentario.descripcion" maxlength="500" rows="4"
            oninput="this.value = this.value.trim().charAt(0).toUpperCase() + this.value.slice(1)"></textarea>
          <mat-error *ngIf=' options.controls.descripcionCtrl.invalid && (options.controls.descripcionCtrl.dirty || options.controls.descripcionCtrl.touched) && options.controls.descripcionCtrl.errors.required'>
            El campo es requerido.</mat-error>
        </mat-form-field>
      </section>

      <section class="ticket-request-dialog__col" aria-label="Prioridad y evidencia">
        <!--Prioridad-->
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="profile-editor-page__field">
          <mat-label>Prioridad</mat-label>
          <mat-select required formControlName='prioridadCtrl' [(ngModel)]="tickets.prioridad">
            <mat-option *ngFor="let items of prioridadesFiltradas" [value]="items.nombre">{{items.nombre}}</mat-option>
          </mat-select>
          <mat-error
            *ngIf=' options.controls.prioridadCtrl.invalid && (options.controls.prioridadCtrl.dirty || options.controls.prioridadCtrl.touched) && options.controls.prioridadCtrl.errors.required'>
            El campo es requerido.</mat-error>
        </mat-form-field>

        <!--Evidencias-->
        <div class="ticket-request-page__evidence">
          <div class="ticket-request-page__evidence-head">
            <h3 class="ticket-request-page__subtitle">Evidencia</h3>
            <div class="ticket-request-page__actions">
              <button class="app-form-btn app-form-btn--secondary app-form-btn--compact btn-file" [disabled]="btnAgrega">
                Agregar
                <input type="file" id="nameFile" aria-label="Agregar" accept="image/*, application/*,file_extension|audio/*|video/*|image/*|media_type" mozdirectory
                  directory multiple (change)='subirEv()' />
              </button>
              <button [disabled]="btnElimina" class="app-form-btn app-form-btn--secondary app-form-btn--compact" type="submit"
                (click)="elimina()">
                Eliminar
              </button>
            </div>
          </div>

          <div class="ticket-request-page__list ticket-request-page__list--files">
            <mat-selection-list [(ngModel)]="selectedOptions"
              (ngModelChange)="onNgModelChange($event)" [ngModelOptions]="{standalone: true}">
              <mat-list-option *ngFor="let item of evidencia; index as i" [value]="item">
                {{item.name}}
              </mat-list-option>
            </mat-selection-list>
            <p class="ticket-request-page__empty ticket-request-page__empty--inside" *ngIf="evidencia.length === 0">
              <i class="material-icons" aria-hidden="true">attach_file</i>
              <span>Aún no agregas archivos.</span>
            </p>
          </div>
        </div>
      </section>
    </div>
  </form>
  <!--Termina form ------------------------------------------------------------>

  <footer class="ticket-request-dialog__footer">
    <button type="button" class="app-form-btn app-form-btn--secondary" (click)="limpiar()">Limpiar</button>
    <button type="button" class="app-form-btn app-form-btn--secondary" (click)='salir()'>Cancelar</button>
    <button type="button" class="app-form-btn app-form-btn--primary" (click)='guardar()' [disabled]="!options.valid" onClick="this.disabled=true">Guardar</button>
  </footer>
</div>